import { j as e } from "../../../jsx-runtime-B6kdoens.js";
import { createElement as n } from "react";
import { a as s } from "../../../index-CROKJrb5.js";
import { w as c } from "../../../atom-provider-B3P183Tj.js";
import { c as p, f as l } from "../../../create-component-CBAeEoQ6.js";
import { M as f } from "../../../motion-jk0ivqSc.js";
import { ToastItem as x } from "../ToastItem/index.js";
import { createToastState as d, ToastContext as u } from "../ToastState/index.js";
import { A as y } from "../../../index-LYq8AemS.js";
import { m as j } from "../../../motion-minimal-Crg_qVxv.js";
const h = {
  initial: { opacity: 0, y: 50, scale: 0.3 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1
  },
  exit: {
    opacity: 0,
    scale: 0.5,
    transition: {
      duration: 0.25,
      delay: 0.1
    }
  },
  transition: { ease: "easeInOut" }
}, k = c(
  p(
    "ToastRenderer",
    l(
      ({ className: t, toasts: r }, i) => /* @__PURE__ */ e.jsx(
        "ul",
        {
          className: s("cur-flex cur-flex-col cur-gap-2", t),
          ref: i,
          "aria-live": "polite",
          children: /* @__PURE__ */ e.jsx(f, { children: /* @__PURE__ */ e.jsx(y, { children: r == null ? void 0 : r.map(({ ref: a, toastId: o, ...m }) => /* @__PURE__ */ n(j.li, { layout: "position", ...h, key: o }, /* @__PURE__ */ e.jsx(x, { toastId: o, ref: a, ...m }))) }) })
        }
      )
    )
  ),
  u,
  d
);
export {
  k as ToastRenderer
};
//# sourceMappingURL=index.js.map
